import { render, staticRenderFns } from "./InfoGeneral.vue?vue&type=template&id=7133f56b&scoped=true&"
import script from "./InfoGeneral.vue?vue&type=script&lang=js&"
export * from "./InfoGeneral.vue?vue&type=script&lang=js&"
import style0 from "./InfoGeneral.vue?vue&type=style&index=0&id=7133f56b&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7133f56b",
  null
  
)

export default component.exports